import { useState } from 'react';
import { api } from '../lib/api.js';
import { useApp } from '../context/AppContext.jsx';
import { cx } from '../lib/util.js';
import { Modal } from './Modal.jsx';

export function PinGate({ open, onSuccess, onCancel, title }) {
  const { setToken, pushToast } = useApp();
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [shake, setShake] = useState(false);

  const cancel = () => {
    if (busy) return;
    setPin('');
    onCancel?.();
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!pin || busy) return;
    setBusy(true);
    try {
      const res = await api.verifyManager(pin);
      setToken(res.token);
      setPin('');
      pushToast('Manager access granted');
      onSuccess?.();
    } catch (err) {
      setShake(true);
      setTimeout(() => setShake(false), 450);
      pushToast(err.message || 'Invalid PIN', 'ember');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open={open} onClose={cancel} title={title || 'Manager Access'} accent="ember">
      <form onSubmit={submit} className="space-y-4">
        <p className="font-mono text-[11px] uppercase tracking-widest text-mist">
          Enter the manager PIN to unlock restricted controls.
        </p>
        <input
          autoFocus
          type="password"
          inputMode="numeric"
          autoComplete="off"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          placeholder="••••"
          className={cx(
            'w-full border border-edge bg-void px-4 py-3 text-center font-mono text-2xl tracking-[0.6em] text-snow outline-none',
            'focus:border-neon focus:shadow-neon-teal',
            shake && 'animate-sg-shake border-ember'
          )}
        />
        <button
          type="submit"
          disabled={!pin || busy}
          className="w-full bg-ember px-4 py-3 font-mono text-sm font-bold uppercase tracking-[0.25em] text-white shadow-neon-ember transition-colors hover:bg-[#ff2b6e] disabled:cursor-not-allowed disabled:opacity-40"
        >
          {busy ? 'Verifying…' : 'Unlock'}
        </button>
      </form>
    </Modal>
  );
}